// extracted by mini-css-extract-plugin
export var menuIcon = "_u8-0";
export var menuIconInline = "_u8-1";